import appReducer from './reducers/appReducer';

const rootReducer = appReducer;

export default rootReducer;